import React, { FunctionComponent } from 'react';

const ReduxWrapper: FunctionComponent<{ element: any }> = ({ element }) => element;

export default ReduxWrapper;
